module.exports = __webpack_public_path__ + "img/1_img.abe6a039.png";